import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { TID } from "../constants/testIds";
import { toast } from "sonner";
import Logo from "../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleAuth() {
  const redirect = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : "/map");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img alt="Aerial parcels" className="absolute inset-0 h-full w-full object-cover" src="https://images.unsplash.com/photo-1516822277566-bb38424a2b77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjB2aWV3JTIwbGFuZCUyMHBhcmNlbHN8ZW58MHx8fHwxNzg1NDI1NTU2fDA&ixlib=rb-4.1.0&q=85" />
        <div className="absolute inset-0 bg-[#0F172A]/70" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-2">
            <Logo size={36} textClass="text-xl" tone="light" />
          </div>
          <div>
            <h2 className="font-display text-4xl font-semibold tracking-tight">Bangalore. Corridor by corridor.</h2>
            <p className="mt-4 text-slate-300 max-w-md">Sign in to unlock full parcel scorecards, the FAR calculator, and 1-on-1 advisory sessions.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-[#0F172A]">
        <div className="w-full max-w-md">
          <h1 className="font-display text-3xl font-semibold tracking-tight">Welcome back</h1>
          <p className="mt-2 text-slate-400 text-sm">Log in to your AcrePulse workspace.</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="e" className="text-xs uppercase tracking-[0.2em] text-slate-400">Email</Label>
              <Input data-testid={TID.loginEmail} id="e" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-[#0F172A] border-[#334155] text-white h-11" />
            </div>
            <div>
              <Label htmlFor="p" className="text-xs uppercase tracking-[0.2em] text-slate-400">Password</Label>
              <Input data-testid={TID.loginPassword} id="p" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-[#0F172A] border-[#334155] text-white h-11" />
            </div>
            <Button data-testid={TID.loginSubmit} type="submit" disabled={busy} className="w-full rounded-full bg-[#10B981] hover:bg-[#059669] text-white h-11">
              {busy ? "Signing in..." : "Sign in"}
            </Button>
          </form>
          <div className="my-6 flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-slate-500">
            <div className="flex-1 h-px bg-[#334155]" /> or <div className="flex-1 h-px bg-[#334155]" />
          </div>
          <Button data-testid={TID.googleLogin} type="button" onClick={googleAuth} variant="outline"
            className="w-full h-11 rounded-full border-[#334155] bg-transparent hover:bg-[#1E293B] hover:text-white text-white">
            Continue with Google
          </Button>
          <p className="mt-8 text-center text-sm text-slate-400">
            New to AcrePulse? <Link to="/signup" className="text-[#10B981] hover:underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
